import { useEffect, useState } from 'react';
import { ChangeEmailRequest } from 'orderme-api-integration-client';
import { DialogProps } from '../../../interfaces/interfaces';
import { CustomerClient } from '../../../helpers/client';
import { Popup } from '../../popup/popup';
import { useTranslation } from 'react-i18next';
import { isValidEmail } from '../../../helpers/validator';
import { resolveErrorMessage } from '../../../helpers/errorMessage';
import { TextField } from '@mui/material';
import { useReloginFlow } from '../../../hooks/useReloginFlow';
import { ReloginConfirmation } from '../login/reloginConfirmation';

export function EmailChange(props: DialogProps) {
  const { onClose, open } = props;
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const customersClient: CustomerClient = new CustomerClient();
  const [email, setEmail] = useState('');
  const [failureText, setFailureText] = useState<string>(null);
  const { t } = useTranslation();
  const { showReloginDialog, reloginMessage, triggerRelogin, handleReloginConfirm } = useReloginFlow();

  useEffect(() => {
    setIsButtonDisabled(!isValidEmail(email));
    setFailureText(null);
  }, [email]);

  const changeEmail = async () => {
    setFailureText(null);

    try {
      const request = new ChangeEmailRequest({ email });
      await customersClient.changeEmail(request);
      setIsButtonDisabled(true);
      handleOnClose();
      triggerRelogin(t('account:emailChanged'));
    } catch (err) {
      setFailureText(resolveErrorMessage(err, t('account:changeEmailError')));
      console.log(err);
    }
  };

  const handleOnClose = () => {
    setFailureText(null);
    setEmail('');
    onClose();
  };

  return (
    <>
      <Popup
        onClose={() => handleOnClose()}
        open={open}
        dialogTitle={t('account:changeEmail')}
        dialogContent={
          <TextField
            sx={{ mt: '10px' }}
            label={t('account:newEmailInput')}
            value={email}
            fullWidth
            autoFocus
            onChange={(e) => setEmail(e.target.value)}
            slotProps={{
              input: {
                sx: {
                  borderRadius: '10px',
                },
              },
            }}
            variant="outlined"
          />
        }
        onAction={changeEmail}
        buttonContent={t('account:confirm')}
        isButtonDisabled={isButtonDisabled}
        isFailure={!!failureText}
        failureText={failureText}
        submitOnEnter
      />
      <ReloginConfirmation open={showReloginDialog} message={reloginMessage} onConfirm={handleReloginConfirm} />
    </>
  );
}
